import { render, staticRenderFns } from "./sendfamilyCards.vue?vue&type=template&id=0ff39cce&scoped=true&"
import script from "./sendfamilyCards.vue?vue&type=script&lang=js&"
export * from "./sendfamilyCards.vue?vue&type=script&lang=js&"
import style0 from "./sendfamilyCards.vue?vue&type=style&index=0&id=0ff39cce&lang=scss&scoped=true&"
import style1 from "./sendfamilyCards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff39cce",
  null
  
)

export default component.exports